<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
}
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  #app
    width:100%;
    height:100%;
    overflow:hidden;
</style>

